import { connect, ConnectedProps } from 'react-redux';
import { RootState } from 'src/store/rootReducer';
import { useNetworkObserver } from 'data-layer-cr/dist/network';
import { Box, makeStyles, createStyles, Typography } from '@material-ui/core';
import { requestPinCreation } from 'src/store/signature/actions';
import { setStepperEmission } from 'src/store/steppers/actions';
import { REQUEST_CREATE_PIN } from 'src/store/signature/requestIdentifiers';
import PinCardLayout from './PinCardLayout';

const useStyles = makeStyles(() =>
  createStyles({
    text: {
      fontWeight: 400,
      fontSize: 15,
      lineHeight: '22px',
      color: '#4a4b4e',
    },
    smallMargin: {
      marginBottom: '20px',
    },
    largeMargin: {
      marginBottom: '40px',
    },
  }),
);

export const RequestPinCard = ({
  isMobile,
  email,
  currentStepEmission,
  requestPinCreationAction,
  setStepperEmissionAction,
}: Props): JSX.Element => {
  const classes = useStyles();
  const requestPinStatus = useNetworkObserver(REQUEST_CREATE_PIN);
  const requestingPin = ['requesting'].includes(requestPinStatus);

  const handleCancelSignature = () => {
    const newStep = currentStepEmission - 1;
    setStepperEmissionAction(newStep);
  };

  return (
    <PinCardLayout
      buttonText="Enviar Pin"
      onCancel={handleCancelSignature}
      onMainClick={requestPinCreationAction}
      isMobile={isMobile}
      loading={requestingPin}
      data-testid="pin-card-layout"
    >
      <Box
        sx={{ mt: 1 }}
        className={isMobile ? classes.largeMargin : classes.smallMargin}
        data-testid="email-section"
      >
        <Typography className={classes.text}>
          El PIN de seguridad se enviará al correo{' '}
          <strong>{`${email}.`}</strong>
        </Typography>
      </Box>
      <Box data-testid="information-section">
        <Typography className={classes.text}>
          O presione cancelar en caso que desee salir del proceso de
          certificación y volver a la pantalla de confirmación de tu cotización.
        </Typography>
      </Box>
    </PinCardLayout>
  );
};

export const mapStateToProps = (
  state: RootState,
): {
  email: string;
  currentStepEmission: number;
} => ({
  email: state.emissionPolicy.dataFields.email,
  currentStepEmission: state.stepper.currentStepEmission,
});

const reduxActions = {
  requestPinCreationAction: requestPinCreation,
  setStepperEmissionAction: setStepperEmission,
};

const connector = connect(mapStateToProps, reduxActions);
type PropsFromRedux = ConnectedProps<typeof connector>;

interface Props extends PropsFromRedux {
  isMobile?: boolean;
}

export default connector(RequestPinCard);
